export function validateEmptyField(field) {
  return !(field == null || field.length === 0 || !field.trim());
}

